export enum MemberTokenType {
  PasswordReset = 'password_reset',
  EmailVerification = 'email_verification',
  Unsubscription = 'unsubscription'
}
